import { Checkbox } from "components/ui/controls/Checkbox";
import styled from "styled-components";
import dragHandleUrl from 'assets/icons/drag_handle_300.svg';
import { useSortable } from "@dnd-kit/react/sortable";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const TaskUndertask = ({undertask, index, onChange, onRemove}) => {
    
    const { ref, handleRef } = useSortable({id: undertask.undertaskUuid, index});

    return (
        <StyledTaskUndertask ref={ref} className={undertask.finished ? 'undertaskFinished' : null}>
            <div ref={handleRef} className="dragHandle"/>
            <Checkbox
                onChange={onChange}
                isChecked={undertask.finished}
            />
            <div className="undertaskDescription">
                {undertask.undertaskDescription}
            </div>
            <MaterialIcon
                name='inventory_2'
                weight={300}
                size="lg"
                color={({theme}) => theme.colors.errorForeground}
                onClick={onRemove}
            />
        </StyledTaskUndertask>
    )
}

const StyledTaskUndertask = styled.label`
    display: flex;
    align-items: center;
    gap: ${({theme}) => theme.spacing.md};
    cursor: pointer;
    transition-duration: 110ms;

    div.dragHandle
    {
        background-image: url(${dragHandleUrl});
        background-size: 110% auto;
        background-position: top center;
        width: 15px;
        height: 20px;
        cursor: grab;
        transition-duration: 110ms;
        
        
        opacity: 0.25;

        &:hover
        {
            opacity: 0.45;
        }
    }

    div.undertaskDescription
    {
        user-select: none;
        flex: 1;
    }

    &.undertaskFinished
    {
        div.undertaskDescription
        {
            text-decoration: line-through;
        }
        
        .icon
        {
            text-decoration-line: none;
        }
    }

    > .icon
    {
        opacity: 0;
        transition-duration: 110ms;
    }

    &:hover
    {
        background: ${({theme}) => theme.colors.mutedBackground};
        
        .icon
        {
            opacity: 1;
        }
    }
`